module.exports = __webpack_public_path__ + "img/avtor.cd820cac.png";